<template>
<div class="container">
    <div class="common-header-wrap">
        <mt-header title="Merchant complaints" class="common-header">
            <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
    </div>

    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
        <div  v-if="complaintList && complaintList.length">
            <div class="mb-10 complaint-item"  v-for="(item, index) in complaintList">
                <div class="complaint-info">
                    <div class="p-img">
                        <img :src="goodsList[item.order_goods_id].goods_image_url"/>
                    </div>
                    <div class="p-info">
                        <div class="explain">{{item.complain_subject_content}}</div>
                        <div class="name">{{item.complain_content}}</div>

                    </div>
                </div>
                <div class="complaint-btn">
                    <div class="buyer-info">Complaint on {{ $moment.unix(item.complain_datetime).format('YYYY-MM-DD') }}</div>
                    <div class="btn-wrapper" v-if="item.complain_state==30">
                        <mt-button size="small" type="primary" class="btn" @click="handleComplain(item.complain_id)">Submit to arbitration</mt-button>
                    </div>
                        <div class="btn-wrapper">
                        <mt-button size="small" type="default" class="btn" @click="$router.push({name:'SellerComplaintForm',query:{complain_id:item.complain_id}})">View</mt-button>
                    </div>
                </div>
            </div>
        </div>
        <empty-record v-else-if="complaintList && !complaintList.length"></empty-record>
    </div>
</div>
</template>

<script>
import { Indicator, MessageBox, Toast } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { getComplaintList, cancelComplaint, handleComplain } from '../../../api/sellerCompliant'
export default {
  name: 'BillList',
  components: {
    EmptyRecord
  },
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      complaintList: false, // 商品列表
      goodsList: false
    }
  },
  methods: {
    handleComplain (complaint_id) {
      handleComplain(complaint_id).then(res => {
        Toast(res.message)
        this.$router.go(0)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    cancelComplaint (order_id) {
      MessageBox.confirm(
        'Are you sure you want to cancel?',
        'Tip',
        {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel'
        }
      ).then(action => {
        cancelComplaint(order_id).then(res => {
          Toast(res.message)
          this.$router.go(0)
        }).catch(function (error) {
          Toast(error.message)
        })
      })
    },
    getComplaintList (ispush) {
      Indicator.open()
      let params = this.params
      getComplaintList(params).then(res => {
        Indicator.close()
        if (res) {
          if (ispush && this.complaintList) {
            this.complaintList = this.complaintList.concat(res.result.complaint_list)
            this.goodsList = Object.assign(this.goodsList, res.result.goods_list)
          } else {
            this.complaintList = res.result.complaint_list
            this.goodsList = res.result.goods_list
          }
          if (res.result.hasmore) {
            this.isMore = true
          } else {
            this.isMore = false
          }
        }
      }).catch(error => {
        Indicator.close()
        Toast(error.message)
      })
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getComplaintList(true)
      }
    }

  }
}
</script>

<style scoped lang="scss">
    .complaint-item{background:#fff;}
    .complaint-info{padding:.5rem;display: flex}
    .complaint-info .p-img{width:4rem;}
    .complaint-info .p-img img{width:4rem;height:4rem;}
    .complaint-info .p-info{flex:1;margin-left:1rem;}
    .complaint-info .p-info .name{font-size:0.7rem;}
    .complaint-info .p-info .explain{font-size:0.7rem;color:$primaryColor;margin-bottom:.5rem}
    .complaint-btn{padding:.5rem;border-top:1px solid #e4e4e4;display: flex}
    .complaint-btn .btn-wrapper{margin-left:.5rem}
    .complaint-btn .btn{float: right}
    .complaint-btn .buyer-info{flex:1;font-size:.7rem;line-height:1.65rem}
</style>
